import { handleApiError } from "@/app/utils/handleApiError";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCustomerInfo,
  updateCustomerProfile,
  updateNotificationPreferences,
  logoutDevice as logoutDeviceService,
} from "./customer.service";
import {
  CustomerInfo,
  CustomerInfoResponse,
  UpdateProfileRequest,
  UpdateNotificationPreferencesRequest,
  UpdateProfileResponse,
} from "./customer.types";
import { ApiResponse } from "../../api/api.types";

/**
 * Normalize API response to frontend structure
 */
const normalizeCustomerInfo = (raw: CustomerInfoResponse): CustomerInfo => ({
  profile: raw.data.profile,
  notification_preferences: raw.data.notification_preferences,
  active_devices: raw.data.active_devices.items,
  login_history: raw.data.login_history.items,
});

export const getCustomerInfo = createAsyncThunk<
  CustomerInfo,
  void,
  { rejectValue: string }
>("customer/getCustomerInfo", async (_, { rejectWithValue }) => {
  try {
    const response = await fetchCustomerInfo();
    return normalizeCustomerInfo(response);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const updateProfile = createAsyncThunk<
  ApiResponse<UpdateProfileResponse>,
  UpdateProfileRequest,
  { rejectValue: string }
>("customer/updateProfile", async (data, { rejectWithValue }) => {
  try {
    return await updateCustomerProfile(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const updatePreferences = createAsyncThunk<
  ApiResponse<null>,
  UpdateNotificationPreferencesRequest,
  { rejectValue: string }
>("customer/updatePreferences", async (data, { rejectWithValue }) => {
  try {
    return await updateNotificationPreferences(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const logoutDevice = createAsyncThunk<
  ApiResponse<null>,
  number,
  { rejectValue: string }
>("customer/logoutDevice", async (deviceId, { rejectWithValue }) => {
  try {
    return await logoutDeviceService(deviceId);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
